var map = {
	"./de.png": "/r2H",
	"./en.png": "gCuF",
	"./es.png": "+wN2",
	"./fr.png": "7IvG",
	"./ja.png": "KjP0",
	"./ko.png": "tlIJ",
	"./pt.png": "juB1",
	"./ru.png": "xoyK",
	"./th.png": "pwAQ",
	"./zh-Hant.png": "w8Dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "sQaW";